import { Text } from 'grommet'
import { UserNew } from 'grommet-icons'

import { getInitials } from './participants'

type Props = {
  name?: string
  size?: string
}
export const AnonymousAvatar = ({ name, size = '16px' }: Props) => {
  if (name) {
    return <Text size={size}>{getInitials(name)}</Text>
  }
  return <UserNew size={size} />
}
